<template>
  <v-app>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#a82420" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Digital Agency</span>
      </v-toolbar-title>

      <v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Поиск"
        class="hidden-sm-and-down"/>

      <v-spacer />

      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>

      <AppAccount/>

    </v-app-bar>

    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app class="mt-3">
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon="">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                    {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" link :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-container class="fill-height" fluid>
        <v-layout align-top class="pb-2">
          <router-view/>
        </v-layout>
      </v-container>
    </v-content>

    <Snackbar ref="snackbar"/>
  </v-app>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue'
import AppAccount from '@/components/AppAccount.vue'

export default {
  components: { Snackbar, AppAccount },
  data: () => ({
    drawer: null,
    items: [
      { icon: 'mdi-monitor-dashboard', text: 'Сводка', link: '/' },
      { icon: 'mdi-timeline-text-outline', text: 'Лента', link: '/timeline' },
      { icon: 'mdi-chart-gantt', text: 'План', link: '/plan' },
      { icon: 'mdi-mail', text: 'Рассылки', link: '/mailings' },
      { icon: 'mdi-menu', text: 'Активности', link: '/activities' },
      { icon: 'mdi-basket-outline', text: 'Shop in shop', link: '/shop-in-shop' },
      { icon: 'mdi-cash-usd-outline', text: 'Финансы', link: '/finances' },
//      { icon: 'mdi-table', text: 'Счета и акты', link: '/documents' },
      { icon: 'mdi-contacts', text: 'Контакты', link: '/contacts' },
      { icon: 'mdi-domain', text: 'Контрагенты', link: '/companies' },
      { icon: 'mdi-view-list', text: 'Прайс-лист', link: '/prices' },
      { icon: 'mdi-palette-advanced', text: 'Инструменты', link: '/spots' },
//      { icon: 'mdi-account', text: 'Пользователи', link: '/users' },
      { icon: 'mdi-face-agent', text: 'Поддержка', link: '/support' }
    ],
  }),
  mounted () {
//    this.$vuetify.lang.current = 'ua'
    this.$root.$alert = this.$refs.snackbar.show
  }
}
</script>

<style scoped>
.v-list-item__action {
  margin: 8px 0;
}
.v-application--is-ltr .v-list-item__action:first-child {
  margin-right: 16px;
}
</style>
